import { render, staticRenderFns } from "./HelpCenterGuider.vue?vue&type=template&id=72ba63fd&"
import script from "./HelpCenterGuider.vue?vue&type=script&lang=js&"
export * from "./HelpCenterGuider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports